/* global BigInt */
import React from 'react';
import { formatEther } from 'viem';
import { estimateMintGas } from '../../web3/useGasFees';

/**
 * Live network fee for the pending mint. Shown because the wallet itself
 * renders "Network fee: Unavailable" on this chain, which reads as something
 * being wrong; stating the real figure -- a fraction of a cent -- removes the
 * doubt before the user ever opens the wallet.
 */
const NetworkFee = ({ fees, quantity }) => {
    if (!fees) return null;

    const gas = estimateMintGas(quantity);
    const cost = gas * fees.effectivePerGas;
    const gwei = Number(fees.effectivePerGas) / 1e9;

    // Below ~0.00001 ETH the formatted value is more zeroes than information.
    const shown = cost < 10000000000000n ? '<0.00001' : Number(formatEther(cost)).toFixed(5);

    return (
        <p className="font-mons text-[11px] sm:text-xs text-white/70 text-center -mt-2 mb-3 tabular-nums">
            Network fee ≈ {shown} ETH · {gwei.toFixed(2)} gwei
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#7BE0A8] ml-2 align-middle" aria-hidden="true" />
            <span className="sr-only">live</span>
        </p>
    );
};

export default NetworkFee;
